import { useEffect } from "react";
import { motion } from "framer-motion";
import { Check, Crown, Coins } from "lucide-react";

// Confirmation animée puis retour automatique vers Découvrir
export function PaymentSuccess({ en, isSubscription, credits, onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 2800);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      className="fixed inset-0 z-[260] flex items-center justify-center bg-black/70 backdrop-blur-md p-6"
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      data-testid="payment-success-overlay"
    >
      <motion.div
        className="lux-panel w-full max-w-sm rounded-2xl px-8 py-10 text-center"
        initial={{ scale: 0.85, y: 30 }} animate={{ scale: 1, y: 0 }} transition={{ type: "spring", damping: 16 }}
      >
        <motion.div
          className="mx-auto mb-6 w-20 h-20 rounded-full bg-[#1c1917] flex items-center justify-center"
          initial={{ scale: 0, rotate: -90 }} animate={{ scale: 1, rotate: 0 }} transition={{ delay: 0.15, type: "spring" }}
        >
          <Check className="w-10 h-10 text-[#d9b779]" strokeWidth={2.5} />
        </motion.div>
        <h2 className="lux-title text-3xl mb-2">{en ? "Payment confirmed" : "Paiement confirmé"}</h2>
        <p className="text-stone-600 text-sm mb-6">{en ? "Thank you! Your account is up to date." : "Merci ! Votre compte est à jour."}</p>
        <motion.div
          className="inline-flex items-center gap-2 rounded-full border border-[#d9b779] px-5 py-2 text-stone-800 font-medium"
          initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.45 }}
          data-testid="payment-success-benefit"
        >
          {isSubscription ? <Crown className="w-4 h-4 text-[#9a7b4f]" /> : <Coins className="w-4 h-4 text-[#9a7b4f]" />}
          {isSubscription ? (en ? `Premium activated · +${credits} credits` : `Premium activé · +${credits} crédits`)
            : (en ? `+${credits} credits added` : `+${credits} crédits ajoutés`)}
        </motion.div>
        <p className="text-[11px] tracking-[0.18em] uppercase text-stone-400 mt-8">
          {en ? "Back to Discover…" : "Retour vers Découvrir…"}
        </p>
      </motion.div>
    </motion.div>
  );
}
